import React from 'react';
import { ArrowUpRightIcon, DownloadCloudIcon } from 'lucide-react';
import { RichText } from './RichText';
interface Highlight {
  value: string;
  label: string;
}
interface ProductCardProps {
  name: string;
  audience: string;
  language: string;
  format: string;
  description: string;
  highlights: Highlight[];
  image: string;
  salesUrl: string;
}
export function ProductCard({
  name,
  audience,
  language,
  format,
  description,
  highlights,
  image,
  salesUrl
}: ProductCardProps) {
  return <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-line bg-canvas" data-id="element-154" data-mp="pawumexfmjt0">
      <div className="aspect-square w-full overflow-hidden bg-ink" data-id="element-155" data-mp="td1mp988f8dj">
        {image ? <img src={image} alt={`${name} product bundle: training volumes and bonus guides`} className="h-full w-full object-contain" loading="lazy" data-id="element-156" data-mp="ycwbn78g5nvy" /> : <div className="flex h-full w-full flex-col items-center justify-center bg-accent-soft p-8 text-center" data-id="element-157" data-mp="2v70uvlq259m0">
            <span className="font-serif text-5xl font-semibold tracking-tight text-ink md:text-6xl" data-id="element-158" data-mp="3lqltagnocus0">{name}</span>
            <span className="mt-3 text-sm text-muted" data-id="element-159" data-mp="3gzlvl96qe8og">{language} edition · Digital delivery</span>
          </div>}
      </div>

      <div className="flex flex-1 flex-col p-6 md:p-8" data-id="element-160" data-mp="3czbplwixvi9l">
        <p className="text-sm font-medium text-accent" data-id="element-161" data-mp="37zpfhvyeqi50"><RichText text={audience} data-id="element-162" data-mp="3810k1xzoftx6" /></p>
        <h3 className="mt-2 font-serif text-3xl font-semibold tracking-tight text-ink" data-id="element-163" data-mp="8kbxec5ypnly">
          <RichText text={name} data-id="element-164" data-mp="8hziy8zexvdn" />
        </h3>
        <p className="mt-3 leading-relaxed text-muted" data-id="element-165" data-mp="4js27e4y8u2g">
          <RichText text={description} data-id="element-166" data-mp="3vp1lkmyfua33" />
        </p>

        <dl className="mt-6 grid grid-cols-3 divide-x divide-line border-y border-line py-4" data-id="element-167" data-mp="3vnqgmjt9awae">
          {highlights.map(h => <div key={h.label} className="px-3 first:pl-0" data-id="element-168" data-mp="3qs1eq9trl3ax">
              <dt className="sr-only" data-id="element-169" data-mp="2kawhzv25028a">{h.label}</dt>
              <dd data-id="element-170" data-mp="2farw1pigmfao">
                <span className="block font-serif text-2xl font-semibold text-ink" data-id="element-171" data-mp="2fa8rdahtlnel">{h.value}</span>
                <span className="mt-0.5 block text-xs text-muted" data-id="element-172" data-mp="2grfiqiyoahqp">{h.label}</span>
              </dd>
            </div>)}
        </dl>

        <dl className="mt-5 grid grid-cols-2 gap-y-2 text-sm sm:grid-cols-3" data-id="element-173" data-mp="2lqie1boup9lh">
          <div data-id="element-174" data-mp="27q7m05bt1oyq">
            <dt className="text-muted" data-id="element-175" data-mp="27qr17ea2lz92">Language</dt>
            <dd className="font-medium text-ink" data-id="element-176" data-mp="2cq3pm3glbedr">{language}</dd>
          </div>
          <div data-id="element-177" data-mp="2cs6prgbginw7">
            <dt className="text-muted" data-id="element-178" data-mp="1y1pmdrf9hnwo">Format</dt>
            <dd className="font-medium text-ink" data-id="element-179" data-mp="1xzwi2is4ffru"><RichText text={format} data-id="element-180" data-mp="22s607cmzvbjk" /></dd>
          </div>
          <div data-id="element-181" data-mp="22tqx38ws76kl">
            <dt className="text-muted" data-id="element-182" data-mp="22u91istlkr3l">Delivery</dt>
            <dd className="flex items-center gap-1.5 font-medium text-ink" data-id="element-183" data-mp="1p1kgjlppuxkm">
              <DownloadCloudIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-184" data-mp="1t23bhomwojr1" />
              100% digital
            </dd>
          </div>
        </dl>

        <div className="mt-auto pt-8" data-id="element-185" data-mp="1f33jq843joqn">
          {salesUrl ? <a href={salesUrl} target="_blank" rel="noopener noreferrer" className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-accent px-4 py-3 text-sm font-semibold text-paper transition-colors duration-150 hover:bg-accent-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2" data-id="element-186" data-mp="1k1y3pddsvjcc">
              View {name}
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-187" data-mp="15h2ed0tde8ip" />
              <span className="sr-only" data-id="element-188" data-mp="1jdfuo6m643vl">(opens sales page in a new tab)</span>
            </a> : <span aria-disabled="true" className="inline-flex w-full cursor-not-allowed items-center justify-center rounded-md border border-dashed border-placeholder-line bg-placeholder px-4 py-3 text-sm font-medium text-placeholder-ink" data-id="element-189" data-mp="1ef4ktvvvhtdd">
              Sales page link to be added
            </span>}
        </div>
      </div>
    </article>;
}